import { useAB } from "@packages/ab";
import { useEffect, useState } from "react";

export const useABLoadingWithTimeout = () => {
  const { isLoading } = useAB();
  const [timedOut, setTimedOut] = useState<boolean>(false);

  useEffect(() => {
    const tm = setTimeout(() => setTimedOut(true), 3000);

    return () => {
      clearTimeout(tm);
    };
  }, []);

  return { isLoading: isLoading && !timedOut };
};
